import type { LevelDefinition } from "@/domain";

import type { PictureWordMatchPayload } from "./types";

const instruction = "图片里是谁呢？看一看，再帮它找到英文名字。";
const promptAudio =
  "/audio/english/instructions/picture-word-match.ogg";

export const pictureWordMatchLevels: LevelDefinition<PictureWordMatchPayload>[] = [
  {
    id: "english-picture-word-match-1",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 1,
    objectives: ["将熟悉的食物图片与英语单词配对"],
    title: "看图找单词 1",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/apple.webp",
      "/audio/english/words/apple.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/apple.webp",
      wordAudio: "/audio/english/words/apple.ogg",
      tokenAudio: {
        apple: "/audio/english/words/apple.ogg",
        ball: "/audio/english/words/ball.ogg"
      },
      choiceTokens: ["apple", "ball"],
      answerTokens: ["apple"]
    }
  },
  {
    id: "english-picture-word-match-2",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 2,
    objectives: ["将熟悉的玩具图片与英语单词配对"],
    title: "看图找单词 2",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/ball.webp",
      "/audio/english/words/ball.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/ball.webp",
      wordAudio: "/audio/english/words/ball.ogg",
      tokenAudio: {
        ball: "/audio/english/words/ball.ogg",
        apple: "/audio/english/words/apple.ogg"
      },
      choiceTokens: ["ball", "apple"],
      answerTokens: ["ball"]
    }
  },
  {
    id: "english-picture-word-match-3",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 3,
    objectives: ["将熟悉的动物图片与英语单词配对"],
    title: "看图找单词 3",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/cat.webp",
      "/audio/english/words/cat.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/cat.webp",
      wordAudio: "/audio/english/words/cat.ogg",
      tokenAudio: {
        cat: "/audio/english/words/cat.ogg",
        dog: "/audio/english/words/dog.ogg",
        ball: "/audio/english/words/ball.ogg"
      },
      choiceTokens: ["cat", "dog", "ball"],
      answerTokens: ["cat"]
    }
  },
  {
    id: "english-picture-word-match-4",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 4,
    objectives: ["在三个英语单词中匹配动物图片"],
    title: "看图找单词 4",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/dog.webp",
      "/audio/english/words/dog.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/dog.webp",
      wordAudio: "/audio/english/words/dog.ogg",
      tokenAudio: {
        dog: "/audio/english/words/dog.ogg",
        cat: "/audio/english/words/cat.ogg",
        book: "/audio/english/words/book.ogg"
      },
      choiceTokens: ["dog", "cat", "book"],
      answerTokens: ["dog"]
    }
  },
  {
    id: "english-picture-word-match-5",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 5,
    objectives: ["在四个英语单词中匹配学习用品图片"],
    title: "看图找单词 5",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/book.webp",
      "/audio/english/words/book.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/book.webp",
      wordAudio: "/audio/english/words/book.ogg",
      tokenAudio: {
        book: "/audio/english/words/book.ogg",
        chair: "/audio/english/words/chair.ogg",
        apple: "/audio/english/words/apple.ogg",
        ball: "/audio/english/words/ball.ogg"
      },
      choiceTokens: ["book", "chair", "apple", "ball"],
      answerTokens: ["book"]
    }
  },
  {
    id: "english-picture-word-match-6",
    domain: "english",
    activityType: "picture-word-match",
    difficulty: 6,
    objectives: ["在四个英语单词中匹配教室物品图片"],
    title: "看图找单词 6",
    instruction,
    promptAudio,
    assets: [
      "/assets/english/vocabulary/chair.webp",
      "/audio/english/words/chair.ogg"
    ],
    payload: {
      kind: "picture-word-match",
      pictureAsset: "/assets/english/vocabulary/chair.webp",
      wordAudio: "/audio/english/words/chair.ogg",
      tokenAudio: {
        chair: "/audio/english/words/chair.ogg",
        book: "/audio/english/words/book.ogg",
        cat: "/audio/english/words/cat.ogg",
        dog: "/audio/english/words/dog.ogg"
      },
      choiceTokens: ["chair", "book", "cat", "dog"],
      answerTokens: ["chair"]
    }
  }
];
